// extracted by mini-css-extract-plugin
export default {"headingBar":"styles_headingBar__apoCS","tableHead":"styles_tableHead__Fd1H6","inputStyle":"styles_inputStyle__SnXKc"};